"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Cordless.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Cordless = function Cordless(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 193.01 180.45"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "line-icon-cordless"), _react2.default.createElement("path", {
    className: "phone",
    d: "M192.65 30.15l-7.4-14.7a3.53 3.53 0 0 0-1.8-1.6L148.15.25a3.75 3.75 0 0 0-3.1.2l-15.7 8.6c-45.7 25.2-92.7 69.2-119.7 112l-9.2 14.6a3.28 3.28 0 0 0-.2 2.9l14.5 32.9a3.15 3.15 0 0 0 1.7 1.7l15.7 7a4 4 0 0 0 1.5.3 3.7 3.7 0 0 0 2.9-1.4l31.5-44.1a3 3 0 0 0-.1-3.7l-17-22.4c14.1-22.3 41.6-47.9 65.4-61.1l24 16a3.66 3.66 0 0 0 3.9.1l47.2-29.4a3.37 3.37 0 0 0 1.2-4.3zm-138.4 94.1l6.7 8.8-28.5 40-9.5-4.2zm64.2-83a3.76 3.76 0 0 0-3.7-.2c-25.8 13.7-56.3 42.2-71 66.3a3 3 0 0 0 .2 3.5l5.9 7.8-31.3 44.7-11.3-25.8 8.4-13.3c12.9-20.4 30.8-41.6 51.7-61.2s43.7-36.3 65.6-48.3l14.2-7.8 27.6 10.6-47.9 29.2zm23.9 15.8l-9.4-6.3 47.8-29.2 4.5 8.8z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = Cordless;